import { render, staticRenderFns } from "./serviceItems.vue?vue&type=template&id=49d08c25&scoped=true"
import script from "./serviceItems.vue?vue&type=script&lang=js"
export * from "./serviceItems.vue?vue&type=script&lang=js"
import style0 from "./serviceItems.vue?vue&type=style&index=0&id=49d08c25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d08c25",
  null
  
)

export default component.exports